export var SchemaVersion = /*#__PURE__*/ function(SchemaVersion) {
    SchemaVersion["V1"] = "1";
    return SchemaVersion;
}({});

//# sourceMappingURL=types.js.map